import { Box } from '../../box';
import styles from './style.module.less';
import { Highlighter } from './highlighter';
import type { ReactElement } from 'react';
import type { DragItemProps } from './types';

// Control 题型区域拖拽时显示组件
export function DragItem(props: DragItemProps): ReactElement {
  const { title = '' } = props;
  return (
    <Box className={styles.designBox}>
      <Box className={styles.subject}>
        <Highlighter
          title={title}
          keyword={''}
          className={styles.title}
        />
      </Box>
    </Box>
  );
}
